import { HelpCircle, Plus } from "lucide-react";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router-dom";
import { CreateCaseDialog } from "~/features/cases/components/CreateCaseDialog";
import { useMobile } from "~/hooks/use-mobile";
import { cn } from "~/lib/utils";
import { trackEvent } from "~/utils/analytics";

declare global {
  interface Window {
    Beacon?: (method: string, options?: unknown, data?: unknown) => void;
  }
}

export function MobileHelpButton() {
  const { isMobile, isLoading } = useMobile();
  const location = useLocation();

  const handleHelpClick = () => {
    if (window.Beacon) {
      window.Beacon("open");
    }
  };

  // Don't render on CasePage - it has its own mobile toolbar with Help button
  const isCasePage = /^\/organizations\/[^/]+\/cases\/[^/]+\/?$/.test(
    location.pathname
  );

  // Check if we're on the Cases page (list of cases)
  const isCasesPage = /^\/organizations\/[^/]+\/cases\/?$/.test(
    location.pathname
  );

  if (isLoading || !isMobile || isCasePage) {
    return null;
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 flex h-14 items-center justify-around border-t bg-background pb-safe-bottom">
      {isCasesPage && (
        <CreateCaseDialog
          TriggerButton={
            <button
              onClick={() =>
                trackEvent({
                  eventName: "app/cases/mobile_create_case.button/click",
                })
              }
              className={cn(
                "flex min-w-[64px] flex-col items-center justify-center gap-1 px-3 py-2",
                "touch-manipulation",
                "text-muted-foreground"
              )}
            >
              <Plus className="h-5 w-5" />
              <span className="text-xs font-medium">
                <FormattedMessage
                  id="mobile.nav.newCase"
                  defaultMessage="New Case"
                />
              </span>
            </button>
          }
        />
      )}
      <button
        onClick={handleHelpClick}
        className={cn(
          "flex min-w-[64px] flex-col items-center justify-center gap-1 px-3 py-2",
          "touch-manipulation",
          "text-muted-foreground"
        )}
      >
        <HelpCircle className="h-5 w-5" />
        <span className="text-xs font-medium">
          <FormattedMessage id="mobile.nav.help" defaultMessage="Help" />
        </span>
      </button>
    </nav>
  );
}
